import React from "react";
import NavbarInfoProduct from "../pages/components/NavbarInfoProduct";
import InfoProductAdd from "../pages/InfoProductAdd";

export default function LayoutInfoProductAdd() {
  return (
    <>
      <NavbarInfoProduct />
      <InfoProductAdd />
    </>
  );
}
